module.exports = __webpack_public_path__ + "static/media/landscape-foto-voorwoord.e28a623c.jpg";